import React, { ForwardedRef } from "react";
import { ButtonVariants } from "../../shared/Button";
import { buttonRecipe, baseButtonStyles, linkStyles } from "../../shared/Button/Button.style";
import { cx } from "../../../styled-system/css";

interface LinkButtonProps {
  href?: string;
  onClick?: React.MouseEventHandler;
  onKeyUp?: React.KeyboardEventHandler<HTMLAnchorElement>;
  variant?: ButtonVariants;
  testSelector?: string;
  openInNewTab?: boolean;
  ariaLabel?: string;
  ariaExpanded?: boolean | "true" | "false";
  ariaControls?: string;
  className?: string;
  rel?: string;
  ref?: ForwardedRef<HTMLAnchorElement>;
  children?: React.ReactNode;
}

export const LinkButton = (props: LinkButtonProps) => {
  const {
    href,
    onClick,
    onKeyUp,
    variant = ButtonVariants.Standard,
    testSelector,
    children,
    openInNewTab = false,
    ariaLabel,
    ariaExpanded,
    ariaControls,
    className,
    rel,
    ref,
  } = props;

  const target = openInNewTab ? "_blank" : "_self";

  return (
    <a
      onClick={onClick}
      onKeyUp={onKeyUp}
      data-testid={testSelector}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControls}
      className={cx(
        variant === ButtonVariants.Text ? linkStyles : cx(baseButtonStyles, buttonRecipe({ variant })),
        className,
      )}
      href={href}
      rel={rel}
      ref={ref}
      target={target}
      tabIndex={0}
    >
      {children}
    </a>
  );
};

LinkButton.displayName = "LinkButton";
